export default "__VITE_ASSET__VZfVWYha__"